import {
  useCheckboxCheck
} from "../__chunks/37OBPWF6.js";
import "../__chunks/M5KYRTQG.js";
import {
  SelectItemCheckedContext
} from "../__chunks/EEVSGAZW.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/select/select-item-check.ts
import { useContext } from "react";
var useSelectItemCheck = createHook(
  (_a) => {
    var _b = _a, { store, checked } = _b, props = __objRest(_b, ["store", "checked"]);
    const context = useContext(SelectItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck(__spreadProps(__spreadValues({}, props), { checked }));
    return props;
  }
);
var SelectItemCheck = createComponent(
  (props) => {
    const htmlProps = useSelectItemCheck(props);
    return createElement("span", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  SelectItemCheck.displayName = "SelectItemCheck";
}
export {
  SelectItemCheck,
  useSelectItemCheck
};
